import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../utilities/AuthContext.js";
import { auth, db } from "../firebase.js";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  sendEmailVerification,
} from "firebase/auth";
import "../components/form.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addDoc, collection, query, where, getDocs } from "firebase/firestore";
import validator from "validator";
// let isUserAuthenticated = false;
// this is not verifying email properly(not working)
const isEmailValid = (email) => {
  return validator.isEmail(email);
};

const toastOptions = {
  position: "bottom-right",
  autoClose: 8000,
  pauseOnHover: true,
  draggable: true,
  theme: "dark",
};

function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  // const BASE_URL = "http://localhost:5000";

  const navigate = useNavigate();
  let errorMsg = "";
  const notifySuccess = (message) => {
    toast.success(message, toastOptions);
  };

  const { login } = useAuth();
  const signUp = async (email, password, name) => {
    try {
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = result.user;
      const docRef = await addDoc(collection(db, "Users"), {
        name: name,
        email: email,
        balance: 0,
        history: [],
        uid: user.uid,
      });
      login(user);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error("Firebase Error Code:", errorCode);
      console.error("Firebase Error Message:", errorMessage);

      // Handle specific error cases
      if (errorCode === "auth/weak-password") {
        errorMsg =
          "The password is too weak. Please choose a stronger password.";
      } else if (errorCode === "auth/email-already-in-use") {
        errorMsg =
          "This email address is already registered. Please sign in or use a different email.";
      } else if (errorCode === "auth/invalid-email") {
        errorMsg = "Invalid email format. Please enter a valid email address.";
      } else {
        errorMsg = "An error occurred during signup. Please try again later.";
      }
      toast.error(errorMsg, toastOptions);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      errorMsg = "Email is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (password === "") {
      errorMsg = "Password is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (cpassword === "") {
      errorMsg = "Confirm Password is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (password !== cpassword) {
      errorMsg = "Password doesn't match";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (!isEmailValid(email)) {
      errorMsg = "Invalid email address.";
      toast.error(errorMsg, toastOptions);
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        email: email,
      };

      // console.log(data);
      const response = await fetch(`${BASE_URL}/sendotp`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log(response);

      if (response.status !== 200) {
        toast.error("Failed to send OTP", toastOptions);
        return;
      } else {
        notifySuccess(
          "OTP sent to your email address. \n Please check spam too."
        );
        setIsOtpSent(true);
      }
    } catch {
      toast.error("Failed to create an account", toastOptions);
    }
    setIsLoading(false);
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const data = {
        email: email,
        otp: otp,
      };

      const response = await fetch(`${BASE_URL}/verifyotp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.status !== 200) {
        toast.error("Failed to verify OTP", toastOptions);
        navigate("/signup");
        return;
      } else {
        await signUp(email, password, name);
        // console.log("signup done");
        notifySuccess("Account created successfully");

        //redirecting to login after sign up, can change this
        navigate("/login");
        setIsOtpSent(false);
      }
    } catch {
      toast.error("Failed to create an account", toastOptions);
    }
    setIsLoading(false);
  };
  const checkAlreadyExists = async (uid) => {
    const q=query(collection(db,"Users"),where("uid","==",uid));
    const querySnapshot = await getDocs(q);
    if(querySnapshot.empty){
      return false;
    }
    else{
      return true;
    }
  }
  const signUpWithGoogle = async () => {
    /* TODO: Setup Sign up with Google */
    const provider = new GoogleAuthProvider();
    // console.log(provider)
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      if(!checkAlreadyExists(user.uid)){
      const docRef = await addDoc(collection(db, "Users"), {
        name: user.displayName,
        email: user.email,
        balance: 0,
        history: [],
        uid: user.uid,
      });
      }
      // console.log(result);
      login(user);
      // console.log(user);
      // User signed in with Google successfully
      navigate("/");
    } catch (error) {
      // Handle any errors here
      console.error(error);
    }
  };
  return (
    <>
      <div className="form-parent form-parent-auth">
        {/* remove post method */}
        {!isOtpSent ? (
          <form onSubmit={handleSubmit}>
            {/* TODO: Update the form action to point to the backend */}
            <div className="form">
              <div>
                <h1 className="text-3xl font-bold">Sign Up</h1>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  type="text"
                  name="mail"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <input
                  type="password"
                  name="cpassword"
                  placeholder="Confirm Password"
                  value={cpassword}
                  onChange={(e) => setCPassword(e.target.value)}
                />
                <button className="filled">Sign Up</button>
                <span className="divider">&mdash; OR &mdash;</span>
                <button
                  className="outline"
                  onClick={(e) => {
                    e.preventDefault();
                    signUpWithGoogle();
                  }}
                >
                  Sign Up with Google
                </button>
                <span>
                  Already have an account? <Link to="/login">Login</Link>{" "}
                  instead.
                </span>
              </div>
              <div>
                <img src="/images/auth.png" alt="" />
                <br />
              </div>
            </div>
          </form>
        ) : (
          <form onSubmit={handleOTPSubmit}>
            <div className="mb-6">
              <label
                htmlFor="otp"
                className="block text-gray-800 font-medium mb-2"
              >
                Enter OTP:
              </label>
              <input
                type="password"
                id="otp"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                }}
                className="w-full py-2 px-4 bg-gray-500 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                required
              />
            </div>

            <div className="flex justify-center mb-6">
              <button
                type="submit"
                className="px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-700 focus:outline-none transition duration-300"
              >
                Verify OTP
              </button>
            </div>
          </form>
        )}
        ;
        {/* {error && <p className="text-red-500 mt-4 text-center">{error}</p>}   */}
      </div>
      {isLoading && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-opacity-50 bg-gray-900">
          <div className="loader">
            <img src="/images/loading.svg" alt="" />
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
}

export default Signup;
